import { DoubleSide } from 'three';

import { LAYERS } from '../../constants.js';

import PBRMaterial from '../PBR/PBR.js';
import replacesFs from './replaces.fs?hotReplace';

export default class Lashes extends PBRMaterial {
	constructor(config, caller) {
		super(config, caller);

		this.transparent = true;
		this.side = DoubleSide;

		replacesFs.use(this);
	}
}
